import { FC } from "react";

import styles from "./voteProgressBar.module.scss";

type TVoteProgressBar = {
    progress?: number
}

export const VoteProgressBar: FC<TVoteProgressBar> = ({ progress }: TVoteProgressBar) => {
    if (progress !== undefined) {
        let chartWidth = 125 * progress + 5;
        let chartPercentage = Math.round(progress * 100);
        let hslColor = progress * 120;

        return (<div style={{width: chartWidth + "px", backgroundColor: "hsl(" + hslColor + ", 100%, 46%)"}} 
            className={styles.voteProgressBar} title={chartPercentage + "%"}></div>);
    } else {
        return (<div className={styles.voteProgressBar}></div>);
    }
}